@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

$avatar-size: 210px;
$no-cdl-background: repeating-linear-gradient(45deg, transparent, transparent 5px, Colors.$col-orange 5px, Colors.$col-orange 10px);
$max-header-title-width: 450px;

.schedule-board-modal {
	&__big-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: Constants.$val-fontSizeXXXBig;
		font-weight: bold;
		overflow: initial !important;

		&::before,
		&::after {
			display: none;
		}
	}

	&__big-header-left {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}

	&__big-header-right {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}

	&__resource {
		// For employees / equipment / placeholders
		&__header-actions {
			max-width: Constants.$val-spacing-xl;
			font-weight: normal;

			.dropdown {
				transform: translate(0px, 28px) !important;
			}

			.options-icon {
				color: Colors.$col-darkGrey;
				font-size: Constants.$val-fontSizeXXXBig;
			}
		}
	}
}
